import { billingAccountsResponseSelector } from "./billingAccountsResponseSelector";
import { RootState } from "../../../store";
import { EmbeddedAccount } from "../../../../services/cloudchipr.api";

export const billingAccountsSelector = (
  state: RootState,
): EmbeddedAccount[] | undefined => {
  return billingAccountsResponseSelector(state)?.data;
};
